<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table :headers="headers" :items="filtered_user_types" class="elevation-1 mytable" dense :search="search">

        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Mark Authority Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-row dense justify="center">
            <v-col cols="auto">
              <v-icon color="error">*</v-icon>
            </v-col>

            <v-col cols="4">
              <v-autocomplete id="userSelect" label="Select User Type" v-model="selected_user_type" :items="user_types"
                item-text="name" item-value="name" outlined required dense class="mt-2" />
            </v-col>

            <v-col cols="auto">
              <v-btn class="primary button mt-2" @click="onFetch" :disabled="!selected_user_type">
                Fetch
              </v-btn>
            </v-col>
          </v-row>

          <v-row dense align="center">
            <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
              <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <v-col class="mr-8" sm="6" md="5" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details />
            </v-col>

            <v-dialog v-model="dialog" max-width="500px">
              <v-card justify="center">
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-col cols="12" class="pb-0">
                    <v-icon color="error" small>*</v-icon>
                    <v-autocomplete label="Select User Type" v-model="editedItem.new_user_type" :items="user_types"
                      item-text="name" item-value="id" outlined dense required hide-details :disabled="editedIndex" />
                  </v-col>

                  <v-col cols="12" class="pt-2 pb-2">
                    <v-icon color="error" small>*</v-icon>
                    <v-autocomplete label="Select Clearance Department" v-model="editedItem.selected_dept_type"
                      :items="dept_types" item-text="name" item-value="id" outlined dense required hide-details
                      :disabled="editedIndex" />
                  </v-col>

                  <v-col cols="12" class="pt-0">
                    <v-icon color="error" small>*</v-icon>
                    <v-autocomplete label="Select Employee" v-model="editedItem.selected_user" :items="users_list"
                      item-text="fullname" item-value="instructor_id" outlined dense required hide-details />
                  </v-col>

                  <v-col cols="12" sm="6" md="4" class="ml-6 pt-0" v-if="editedIndex != -1">
                    <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                  </v-col>

                  <v-card-actions class="justify-center pt-0">
                    <v-btn class="button" @click="close()" :disabled="!valid">
                      Cancel
                    </v-btn>

                    <v-btn color="primary button" @click="save" :disabled="!valid" v-if="editedIndex === -1">
                      Save
                    </v-btn>

                    <v-btn color="primary button" @click="updateAuthority" v-else>
                      Update
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.instructor="{ item }">
          <div class="text-center">
            <span v-if="item.instructor">{{ item.instructor }}</span>
            <v-btn v-else icon small color="primary" @click="editItem(item, true)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.is_last_approving="{ item }">
          <v-icon :color="item.is_last_approving ? 'success' : 'error'">
            {{ item.is_last_approving ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
          </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar size="25" class="edit-avatar" v-if="item.instructor">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>

            <v-avatar size="25" class="delete-avatar ml-2" v-if="item.instructor">
              <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
            </v-avatar>
          </div>
        </template>

        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'" @change="toggle(item)"
            v-if="item.instructor">
          </v-switch>
          <div v-else style="height: 70px;"></div>
        </template>
      </v-data-table>
    </v-card>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default {
  components: { Breadcrumbs },
  data: () => ({
    valid: false,
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    selected_user_type: "",
    selected_dept_type: "",
    new_user_type: "",
    dept_name: "",
    selected_user: "",
    clearance_dept_list: [],
    user_types: [],
    dept_types: [],
    dialog: false,
    headers: [
      {
        text: "Level",
        align: "left",
        value: "level",
        width: '50px'
      },
      {
        text: "User Type",
        align: "center",
        sortable: false,
        value: "usertype",
        width: '150px'
      },
      {
        text: "Clearance Department",
        align: "center",
        sortable: false,
        value: "name",
        width: '200px'
      },
      {
        text: "Employee",
        sortable: false,
        align: "center",
        value: "instructor",
        width: '220px'
      },
      {
        text: "Is Active",
        align: "left",
        value: "isactive",
        width: '150px'
      },
      {
        text: "Actions",
        value: "action",
        sortable: false,
        width: '150px'
      },
    ],
    hasFetched: false,
    filtered_user_types: [],
    users_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      new_user_type: "",
      selected_dept_type: "",
      selected_user: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() { return this.editedIndex === -1 ? "Add New Authority" : "Update Authority"; },
  },

  watch: {
    dialog(val) { val || this.close(); },
  },

  mounted() {
    this.onLoad();
    this.getInstructorsData();
    this.getUsers();
  },

  methods: {
    downloadFile() {
      this.loader = true;
      const excelData = this.filtered_user_types.map((item, index) => ({
        "Level": item.level,
        "User Type": item.usertype,
        "Clearance Department": item.name,
        "Employee": item.instructor ? item.instructor : "Not Assigned",
        "Status": item.isactive ? "Active" : "Inactive"
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Authority");
      XLSX.writeFile(workbook, "Authority.xlsx");

      this.loader = false;
    },

    editItem(item, isAdd = false) {
      this.editedIndex = isAdd ? -1 : this.filtered_user_types.indexOf(item);

      this.editedItem = {
        id: item.id,
        isactive: item.isactive,
        new_user_type: item.usertype_id,
        selected_dept_type: item.id,
        selected_user: isAdd ? null : item.instructor_id
      };

      this.new_user_type = item.usertype_id;
      this.selected_dept_type = item.id;
      this.dept_name = item.name;
      this.dialog = true;
    }
    ,
    onFetch() {
    this.getDept()
    },

    onLoad() {
      this.overlay = true;
      axios.post("/Dues/getUserTypes")
        .then(res => {
          this.overlay = false;
          if (res.data.msg === "200") {
            this.user_types = res.data.user_types;
          } else {
            this.showSnackbar("#b71c1c", "Failed to load User Types");
          }
        })
        .catch(err => console.log(err));
    },

    getDept() {
      this.overlay = true;
      axios.post("/Dues/getClearanceDepartments")
        .then(res => {
          this.overlay = false;
          if (res.data.msg === "200") {
            this.dept_types = res.data.dept_types;
            this.filteredList();
          } else {
            this.showSnackbar("#b71c1c", "Failed to load Departments");
          }
        })
        .catch(err => console.log(err));
    },

    getInstructorsData() {
      this.overlay = true;
      axios.post("/Dues/getInstructorsData")
        .then(res => {
          this.overlay = false;
          if (res.data.msg === "200") {
            this.clearance_dept_list = res.data.clearance_dept_list;
          } else {
            this.showSnackbar("#b71c1c", "Failed to load Instructors Data");
          }
        })
        .catch(err => console.log(err));
    },

    getUsers() {
      this.overlay = true;
      axios.post("/Dues/getUsers")
        .then(res => {
          this.overlay = false;
          if (res.data.msg === "200") {
            this.users_list = res.data.users_list;
          } else {
            this.showSnackbar("#b71c1c", "Failed to load Users");
          }
        })
        .catch(err => console.log(err));
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
    },

    save() {
      if (this.editedItem.new_user_type && this.editedItem.selected_dept_type && this.editedItem.selected_user) {

        const payload = {
          user_type_id: this.editedItem.new_user_type,
          clearance_department_id: this.editedItem.selected_dept_type,
          instructor_id: this.editedItem.selected_user,
        };

        axios.post("/Dues/saveAuthority", payload)
          .then(res => {
            if (res.data.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Authority Added Successfully");
              this.getDept();
            } else if (res.data.code === "NA") {
              this.showSnackbar("#b71c1c", "Authority Already Present!!!");
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong");
            }
          });
        this.close();
      } else {
        this.showSnackbar("#b71c1c", "Please fill all mandatory fields");
      }
    },

    isValidated() {
      return !!this.editedItem.display_name;
    },

    toggle(item) {
      const data = {
        clearance_department_id: item.id,
        instructor_id: item.instructor_id,
        user_type_id: item.usertype_id,
        toggle: item.isactive
      };
      this.overlay = true;
      axios.post("/Dues/toggleActive", data)
        .then(res => {
          this.overlay = false;
          if (res.data.code === "SUCCESS") {
            this.showSnackbar("#4caf50", "Authority Updated!");
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch(err => this.overlay = false);
    },

    updateAuthority() {
      if (
        this.editedItem.new_user_type &&
        this.editedItem.selected_dept_type &&
        this.editedItem.selected_user
      ) {
        const payload = {
          user_type_id: this.editedItem.new_user_type,
          clearance_department_id: this.editedItem.selected_dept_type,
          instructor_id: this.editedItem.selected_user,
          isactive: this.editedItem.isactive,
        };

        axios.post("/Dues/editAuthority", payload)
          .then(res => {
            if (res.data.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Authority Updated Successfully");
              this.getDept();
              this.close();
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong!");
            }
          });
      } else {
        this.showSnackbar("#b71c1c", "Please fill all mandatory fields");
      }
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this Authority?")) {
        const data = {
          clearance_department_id: item.id,
          instructor_id: item.instructor_id,
          user_type_id: item.usertype_id
        };
        axios.post("/Dues/deleteAuthority", data)
          .then(res => {
            if (res.data.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Authority Deleted Successfully...");
              this.getDept();
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong!");
            }
          })
          .catch(err => console.log(err));
      }
      this.close();
    },

    filteredList() {
      if (!this.selected_user_type) {
        this.filtered_user_types = [];
        return;
      }
      this.hasFetched = true;
      this.filtered_user_types = this.dept_types.filter(
        item => item.usertype === this.selected_user_type
      );
    }
  }

};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.mytable /deep/ thead th {
  background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}

.v-btn.v-btn--disabled {
  border: none !important;
}
</style>
